import React from "react";
import {Alert, Box} from "@mui/material";
import {Portal} from "@mui/material";

interface ErrorAlertProps {
    message: string;
    onClose: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({message, onClose}) => {
    return (
        <Portal>
            <Box
                sx={{
                    position: "fixed",
                    top: "3.5rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000,
                    width: "80%",
                    maxWidth: "600px",
                }}
            >
                <Alert severity="error" onClose={onClose} sx={{width: "100%"}}>
                    {message}
                </Alert>
            </Box>
        </Portal>
    );
};
